// src/helpers/url_helper.js

// Authentication URLs
export const POST_LOGIN = "api/accounts/login?include_auth_token=1";
export const POST_REGISTER = "api/accounts/register?include_auth_token=1";
export const POST_FORGOT_PASSWORD = "api/accounts/reset";
export const POST_RESET_PASSWORD = (token) => `api/accounts/reset/${token}`;

// Dashboard & Projects
export const GET_PROJECTS = "/api/landing";

// Invite
export const POST_SEND_INVITE = "/api/invite/";

// Contact Us
export const POST_CONTACT_US = "/api/contactus/";

// Short Code
export const GET_SHORT_CODE_DATA = (shortCode) => `/api/short/${shortCode}/`;

// Updates & Settings
export const GET_UPDATES = "/api/updates";
export const GET_SETTINGS = "/api/settings/";
export const POST_SETTINGS_UPDATE = "/api/settingsquery";

// Connect-plus status
export const PLUS_STATUS = (projectId) =>
 `/api/${projectId}/plus_status/`;

// Sample grouping URLs
export const SAMPLE_GROUPING = (projectId) =>
 `/api/${projectId}/sample_groupings/`;
 export const POST_SAMPLE_GROUPING = "/api/sample_groupings_query/";

// Used by Connect+ to create short codes specific to batch jobs
 export const POST_CREATE_BATCH_CODE = "/api/create_batch_code";

// Used by Connect+ to create batch downloads
 export const POST_CREATE_BATCH_DOWNLOAD = "/api/create_batch_download";

// Sub-codon Profile URLs
export const GET_INTERACTIVE_PLOT_DATA = (projectId) =>
  `/api/${projectId}/interactive_plot/`;
export const GET_BATCH_PROFILE_DATA = (projectId) =>
  `/api/${projectId}/batch_profiles/`;

export const POST_GENERATE_BATCH_SUBCODON_PLOT = "/api/bulk_query";
export const POST_GENERATE_SUBCODON_PLOT = "/api/query";

// Comparison Profile URLs

export const GET_COMPARISON_PLOT_DATA = (projectId) =>
  `/api/${projectId}/comparison/`;
export const GET_BATCH_COMPARISON_PROFILE_DATA = (projectId) =>
  `/api/${projectId}/batch_comparison_profiles/`;

export const POST_GENERATE_COMPARISON_PLOT = "/api/comparequery";
export const POST_BULK_COMPARE_QUERY = "/api/bulk_comparequery";

// Differential Expression endpoints
export const GET_DIFFERENTIAL_PLOT_DATA = (projectId) =>
  `/api/${projectId}/differential/`;

export const POST_GENERATE_DIFFERENTIAL_PLOT = "/api/diffquery";

// Data Quality URLs
export const GET_DATA_QUALITY_PLOT_DATA = (projectId) =>
  `/api/${projectId}/metainfo_plot/`;

export const POST_GENERATE_DATA_QUALITY_PLOT = "/api/metainfoquery";

export const GET_PAUSE_DETECTION_DATA = (projectId) =>
  `/api/${projectId}/pause_detection/`;

export const POST_GENERATE_PAUSE_DETECTION = "/api/pausequery";

export const GET_TRANSLON_EXPLORER_DATA = (projectId) =>
  `/api/${projectId}/orf_translation/`;

export const POST_GENERATE_TRANSLON_EXPLORER = "/api/orfquery";

export const GET_CODON_OCCUPANCY_DATA = (projectId) =>
  `/api/${projectId}/codon_occupancy/`;

export const POST_GENERATE_CODON_OCCUPANCY = "/api/codon_occupancy_query";

export const GET_TASK_STATUS = (taskId) => `/api/task_status/?task_id=${taskId}`;

export const GET_TRANSCRIPTOME_INFO_DATA = (projectId) =>
  `/api/${projectId}/traninfo_plot/`;

export const POST_GENERATE_TRANSCRIPTOME_INFO = "/api/traninfoquery";

export const GET_TIME_SERIES_DATA = (projectId) => `/api/${projectId}/time_series/`;

export const POST_GENERATE_TIME_SERIES_PLOT = "/api/time_series_query";

export const GET_POLYSHIFT_DATA = (projectId) => `/api/${projectId}/poly_shift/`;

export const POST_GENERATE_POLYSHIFT_PLOT = "/api/poly_shift_query";

export const GET_DIFFERENTIAL_SILHOUETTE_DATA = (projectId) =>
  `/api/${projectId}/differential_silhouette/`;

export const POST_DIFFERENTIAL_SILHOUETTE_QUERY = "/api/diff_sil_query";

export const GET_DIFFERENTIAL_CDS_LEADER_DATA = (projectId) =>
  `/api/${projectId}/diff_leader_cds/`; 

export const POST_DIFFERENTIAL_CDS_LEADER_QUERY = "/api/diff_uorf_query";

export const GET_RRTS_DATA = (projectId) => `/api/${projectId}/rrts/`;

export const POST_GENERATE_RRTS_TABLE = "/api/rrtsquery";

export const GET_UTR_PERIODICITY_DATA = (projectId) =>
  `/api/${projectId}/utr_periodicity/`;

export const POST_UTR_PERIODICITY_QUERY = "/api/utr_periodicity_query";

export const GET_TERMINATION_METAGENE_DATA = (projectId) =>
  `/api/${projectId}/termination_metagene/`;

export const POST_TERMINATION_METAGENE_QUERY = "/api/termination_metagene_query";

export const GET_SINGLE_GENOME_BROWSER_DATA = (projectId, html_params) =>
  `/api/${projectId}/single_genomebrowser/?${html_params}`;

export const GET_COMPARISON_GENOME_BROWSER_DATA = (projectId, html_params) =>
  `/api/${projectId}/comparison_genomebrowser/?${html_params}`;
